import PermissionType from "@/models/Settings/Roles/PermissionType";

export default class NavigationMenuItem {
    path: string;
    text: any;
    icon: string;
    permission: PermissionType;

    constructor(path: string, text: any, icon: string, permission: PermissionType){
        this.path = path;
        this.text = text;
        this.icon = icon;
        this.permission = permission;
    }
}